import { Navigate } from 'react-router-dom'

import { SidebarLayout } from '@/layouts'
import { ROUTES } from '@/config/routes'
import { useCurrentUser } from '@/features/auth/state/auth'

const AdminRoute = ({ children }: { children: JSX.Element }) => {
  const user = useCurrentUser()

  if (!user) {
    return <Navigate to={ROUTES.SIGNIN.path} />
  }

  if (user.typeUser !== 'ADMIN') {
    return <Navigate to={ROUTES.HOME.path} />
  }

  return <SidebarLayout>{children}</SidebarLayout>
}

export default AdminRoute
